export default "__VITE_ASSET__DhTYZeG2__"